import React, { Component } from "react";
import { States } from "../../components";
import "../../styles/css/users/Profile.css";
import ErrorOutileIcon from "@material-ui/icons/ErrorOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
// file upload
import "filepond/dist/filepond.min.css";
import API from "../../api/api";

// import { FormErrors } from "./FormErrors";

import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

class ProfileDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      city: "",
      created_at: "",
      designation: "",
      ein: "",
      email: "",
      ext: "",
      first_name: "",
      last_name: "",
      license_no: "",
      mobile_no: "",
      name: "",
      signature_image_url: [],
      state: "",
      userRole: "",
      zipcode: "",
      equipments: [],

      description: "",
      states: States,
      files: [],

      isLoggedUser: false,
      password: "",

      nameEmpty: false,
      emailEmpty: false,
      licenseEmpty: false,
      einEmpty: false,
      phoneEmpty: false,
      addressEmpty: false,
      stateEmpty: false,
      zipCodeEmpty: false,
      cityEmpty: false,
      extEmpty: false,
      designationEmpty: false,
      firstNameEmpty: false,
      lastNameEmpty: false,
      signatureEmpty: false,
      equipmentsEmpty: false,
      mobile_noEmpty: false,

      extMinus: false,
      license_noMinus: false,
      zipCodeMinus: false,
      phoneMinus: false,
      licenseMinus: false,
      einMinus: false,
      mobile_noMinus: false,

      isEditing: false,
      isSubmitted: false,
      userCreationSuccess: false,
      isEditLoading: false,
      submitDisabled: false,
      isDeleted: false,

      isSaveLoading: false,
    };
  }

  componentDidMount() {
    this.setState({
      name: this.props.profileData.name,
      userRole: this.props.profileData.user_roles[0].name,
      email: this.props.profileData.email,
      license_no: this.props.profileData.license_no,
      ein: this.props.profileData.ein,
      mobile_no: this.props.profileData.mobile_no,
      address: this.props.profileData.address,
      state: this.props.profileData.state,
      zipcode: this.props.profileData.zipcode,
      created_at: this.props.profileData.created_at.date.split(" ")[0],
      isLoggedUser: this.props.isLoggedUser,
      designation: this.props.profileData.designation,
      first_name: this.props.profileData.first_name,
      last_name: this.props.profileData.last_name,
      city: this.props.profileData.city,
      ext: this.props.profileData.ext,
      signature_image_url: this.props.profileData.signature_image_url,
      equipments:
        this.props.profileData.equipments !== null
          ? this.props.profileData.equipments.split(",")
          : null,
    });
  }

  inputHandleChange = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;

    this.setState(
      {
        [name]: value,
        [`${name}Empty`]: false,
      },
      () => this.checkMinus(name, value)
    );
  };

  checkMinus = (name, value) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (name === "zipcode" && value !== null && value < 0) {
      this.setState({ zipCodeMinus: true });
    } else if (name === "zipcode" && value !== null && value >= 0) {
      this.setState({ zipCodeMinus: false });
    }
    if (name === "mobile_no" && value !== null && value < 0) {
      this.setState({ mobile_noMinus: true });
    } else if (name === "mobile_no" && value !== null && value >= 0) {
      this.setState({ mobile_noMinus: false });
    }
    if (
      (name === "mobile_no" && value !== null && value === "") ||
      (name === "mobile_no" && value.length < 10) ||
      (name === "mobile_no" && value.length > 10)
    ) {
      this.setState({ mobile_noEmpty: true });
    } else if (
      (name === "mobile_no" && value !== null && value !== "") ||
      (name === "mobile_no" && value.length === 10)
    ) {
      this.setState({ mobile_noEmpty: false });
    }

    if (name === "license_no" && value !== null && value < 0) {
      this.setState({ license_noMinus: true });
    } else if (name === "license_no" && value !== null && value >= 0) {
      this.setState({ license_noMinus: false });
    }

    if (name === "license_no" && value !== null && value === "") {
      this.setState({ licenseEmpty: true });
    } else if (name === "license_no" && value !== null && value !== "") {
      this.setState({ licenseEmpty: false });
    }

    if (name === "ein" && value !== null && value < 0) {
      this.setState({ einMinus: true });
    } else if (name === "ein" && value !== null && value >= 0) {
      this.setState({ einMinus: false });
    }

    if (name === "first_name" && value !== null && value === "") {
      this.setState({ firstNameEmpty: true });
    } else if (name === "first_name" && value !== null && value !== "") {
      this.setState({ firstNameEmpty: false });
    }
    if (name === "last_name" && value !== null && value === "") {
      this.setState({ lastNameEmpty: true });
    } else if (name === "last_name" && value !== null && value !== "") {
      this.setState({ lastNameEmpty: false });
    }
    if (name === "name" && value !== null && value === "") {
      this.setState({ nameEmpty: true });
    } else if (name === "name" && value !== null && value !== "") {
      this.setState({ nameEmpty: false });
    }
    if (name === "designation" && value !== null && value === "") {
      this.setState({ designationEmpty: true });
    } else if (name === "designation" && value !== null && value !== "") {
      this.setState({ designationEmpty: false });
    }
    if (name === "email" && value !== null && value === "") {
      this.setState({ emailEmpty: true });
    } else if (name === "email" && value !== null && value !== "") {
      this.setState({ emailEmpty: false });
    }

    if (name === "email" && value !== "" && !pattern.test(value)) {
      this.setState({ emailValid: true });
    } else if (name === "email" && value !== "" && pattern.test(value)) {
      this.setState({ emailValid: false });
    }

    if (name === "ext" && value !== null && value === "") {
      this.setState({ extEmpty: true });
    } else if (name === "ext" && value !== null && value !== "") {
      this.setState({ extEmpty: false });
    }
    if (name === "ext" && value !== null && value < 0) {
      this.setState({ extMinus: true });
    } else if (name === "ext" && value !== null && value > 0) {
      this.setState({ extMinus: false });
    }
    if (name === "address" && value !== null && value === "") {
      this.setState({ addressEmpty: true });
    } else if (name === "address" && value !== null && value !== "") {
      this.setState({ addressEmpty: false });
    }
    if (name === "city" && value !== null && value === "") {
      this.setState({ cityEmpty: true });
    } else if (name === "city" && value !== null && value !== "") {
      this.setState({ cityEmpty: false });
    }

    if (name === "zipcode" && value !== null && value === "") {
      this.setState({ zipCodeEmpty: true });
    } else if (name === "zipcode" && value !== null && value !== "") {
      this.setState({ zipCodeEmpty: false });
    }

    if (name === "state" && value === null) {
      this.setState({ stateEmpty: true });
    } else if (name === "state" && value !== null) {
      this.setState({ stateEmpty: false });
    }
    if (name === "equipments" && value.length === 0) {
      this.setState({ equipmentsEmpty: true });
    } else if (name === "equipments" && value.length > 0) {
      this.setState({ equipmentsEmpty: false });
    }
  };

  removeTag = (i) => {
    const newequipments = [...this.state.equipments];
    newequipments.splice(i, 1);
    this.setState({ equipments: newequipments });
  };

  inputKeyDown = (e) => {
    const val = e.target.value;

    if (e.key === "Enter" && val) {
      if (
        this.state.equipments.find(
          (tag) => tag.toLowerCase() === val.toLowerCase()
        )
      ) {
        return;
      }
      this.setState({
        equipments: [...this.state.equipments, val],
      });

      this.tagInput.value = null;
    } else if (e.key === "Backspace" && !val) {
      this.removeTag(this.state.equipments.length - 1);
    }
  };
  _deleteSignature = (e) => {
    this.setState({
      isDeleted: true,
    });

    e.preventDefault();
  };
  stateHandleChange = (e) => {
    this.setState({ state: e.target.value });
  };

  editProfile = (e) => {
    e.preventDefault();
    this.setState({ isEditing: true });
  };
  submitEdit = (e) => {
    this.setState({ isSaveLoading: true });

    const userDetails = {
      name: this.state.name,
      userRole: this.props.profileData.user_roles[0].name,
      email: this.state.email,
      license_no: this.state.license_no,
      ein: this.state.ein,
      mobile_no: this.state.mobile_no,
      address: this.state.address,
      state: this.state.state,
      zipcode: this.state.zipcode,
      created_at: this.props.profileData.created_at.date.split(" ")[0],
      isLoggedUser: this.props.isLoggedUser,
      designation: this.state.designation,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      city: this.state.city,
      ext: this.state.ext,
      equipments: this.state.equipments,
      user_id: this.props.profileData.id,
    };
    var formUserData = new FormData();
    if (this.state.files.length > 0) {
      Object.keys(userDetails).forEach((key) => {
        formUserData.append(key, userDetails[key]);
      });
      this.state.files.map((file, i) => {
        formUserData.append("signature_image_url[]", file, file.name);
        return 0;
      });
    } else {
      Object.keys(userDetails).forEach((key) => {
        formUserData.append(key, userDetails[key]);
      });
    }
    e.preventDefault();
    API.post(`user/update_user_profile`, formUserData)
      .then(async (res) => {
        console.log(res);
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Your profile has been saved",
            timer: 1500,
          });
          this.setState({
            isEditing: false,
            isSaveLoading: false,
          });
        }

        window.location.reload();
      })
      .catch((err) => {
        console.log("AXIOS ERROR", err);
        this.setState({
          isSaveLoading: false,
        });
      });
  };
  cancelSubmit = (e) => {
    e.preventDefault();
    this.setState({ isEditing: false, isSaveLoading: false });
    window.location.reload();
  };

  render() {
    const {
      isEditing,
      isSaveLoading,
      submitSaveDisabled,
      isSubmitted,
      submitDisabled,
      userCreationSuccess,
      states,
      isDeleted,
    } = this.state;
    console.log(this.state);
    return (
      <div className="headerCardRoot">
        <div className="headerCardMain" style={{ height: "auto" }}>
          <form
            onKeyPress={(event) => {
              if (event.which === 13 /* Enter */) {
                event.preventDefault();
              }
            }}
          >
            <div className="profileColor">
              {isEditing ? (
                <div className="formMainRow">
                  <div className="formInnerRow halfRow">
                    <div className="formInputLabelNew">First Name</div>
                    <div className="halfInput">
                      <div>
                        <input
                          type="text"
                          id="first_name"
                          name="first_name"
                          value={this.state.first_name}
                          className="textInput"
                          onChange={this.inputHandleChange}
                        />
                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.firstNameEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>First name is required</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="formInnerRow halfRow">
                    <div className="innerRowDiv">
                      <div className="formInputLabelNewHalf">Last Name</div>
                      <div className="formInputDiv customInput3">
                        <div>
                          <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            value={this.state.last_name}
                            className="textInput"
                            onChange={this.inputHandleChange}
                          />
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.lastNameEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Last name is required</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="formMainRow">
                  <div className="formInnerRow halfRow">
                    <div className="formInputLabelNew">Name</div>
                    <div className="halfInput">
                      <div className="jobViewData">
                        {this.state.first_name} {this.state.last_name}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">User role</div>
                  <div className="formInputDiv">
                    <div className="jobViewData">{this.state.userRole}</div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Company Name</div>
                  <div className="formInputDiv">
                    {/* {isEditing ? (
                      <div>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={this.state.name}
                          className="textInput"
                          onChange={this.inputHandleChange}
                        />
                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.nameEmpty ? "block" : "none",
                          }}
                        >
                          <span> Company name is required</span>
                        </div>
                      </div>
                    ) : ( */}
                    <div className="jobViewData">{this.state.name}</div>
                    {/* )} */}
                  </div>
                </div>
              </div>

              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Title</div>
                  <div className="formInputDiv">
                    {isEditing ? (
                      <div>
                        <input
                          type="text"
                          id="designation"
                          name="designation"
                          value={this.state.designation}
                          className="textInput"
                          onChange={this.inputHandleChange}
                        />
                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.designationEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Title is required</span>
                        </div>
                      </div>
                    ) : (
                      <div className="jobViewData">
                        {this.state.designation}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Email</div>
                  <div className="formInputDiv">
                    <div className="jobViewData">{this.state.email}</div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                {this.state.userRole === "Surveyor" ? (
                  <div className="formInnerRow">
                    <div className="formInputLabelNew">License number</div>
                    <div className="formInputDiv">
                      {isEditing ? (
                        <div>
                          <input
                            type="text"
                            id="license_no"
                            name="license_no"
                            value={this.state.license_no}
                            className="textInput"
                            onChange={this.inputHandleChange}
                          />
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.licenseEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>License number is required</span>
                          </div>
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.license_noMinus
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                        </div>
                      ) : (
                        <div className="jobViewData">
                          {this.state.license_no}
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="formInnerRow">
                    <div className="formInputLabelNew">EIN</div>
                    <div className="formInputDiv">
                      {isEditing ? (
                        <div>
                          <input
                            type="text"
                            id="ein"
                            name="ein"
                            value={this.state.ein}
                            className="textInput"
                            onChange={this.inputHandleChange}
                          />
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.einEmpty ? "block" : "none",
                            }}
                          >
                            <span>License number is required</span>
                          </div>
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.einMinus ? "block" : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                        </div>
                      ) : (
                        <div className="jobViewData">{this.state.ein}</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="formMainRow">
                <div className="formInnerRow halfRow">
                  <div className="formInputLabelNew">Phone number</div>
                  <div className="halfInput">
                    {isEditing ? (
                      <div>
                        <input
                          type="number"
                          id="mobile_no"
                          name="mobile_no"
                          value={this.state.mobile_no}
                          className="textInput"
                          onChange={this.inputHandleChange}
                          required
                        />
                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.mobile_noEmpty
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Please enter valid phone number</span>
                        </div>

                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.mobile_noMinus
                              ? "block"
                              : "none",
                          }}
                        >
                          <span>Minus values are not allowed</span>
                        </div>
                      </div>
                    ) : (
                      <div className="jobViewData">{this.state.mobile_no}</div>
                    )}
                  </div>
                </div>
                <div className="formInnerRow halfRow">
                  <div className="innerRowDiv">
                    <div className="formInputLabelNewHalf">Ext.</div>
                    <div className="formInputDiv customInput3">
                      {isEditing ? (
                        <div>
                          <input
                            type="number"
                            id="ext"
                            name="ext"
                            value={this.state.ext}
                            className="textInput"
                            onChange={this.inputHandleChange}
                          />
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.extEmpty ? "block" : "none",
                            }}
                          >
                            <span>Ext code is required</span>
                          </div>
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.extMinus ? "block" : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                        </div>
                      ) : (
                        <div className="jobViewData">{this.state.ext}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Address</div>
                  <div className="formInputDiv">
                    {isEditing ? (
                      <div>
                        <input
                          type="text"
                          id="address"
                          name="address"
                          value={this.state.address}
                          className="textInput"
                          onChange={this.inputHandleChange}
                        />
                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.addressEmpty ? "block" : "none",
                          }}
                        >
                          <span>Address is required</span>
                        </div>
                      </div>
                    ) : (
                      <div className="jobViewData">{this.state.address}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">City</div>
                  <div className="formInputDiv">
                    {isEditing ? (
                      <div>
                        <input
                          type="text"
                          id="city"
                          name="city"
                          value={this.state.city}
                          className="textInput"
                          onChange={this.inputHandleChange}
                        />
                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.cityEmpty ? "block" : "none",
                          }}
                        >
                          <span>City is required</span>
                        </div>
                      </div>
                    ) : (
                      <div className="jobViewData">{this.state.city}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow halfRow">
                  <div className="formInputLabelNew">State</div>
                  <div className="halfInput">
                    {isEditing ? (
                      <div>
                        <select
                          id="state"
                          name="state"
                          value={this.state.state}
                          className="textInput"
                          onChange={this.stateHandleChange}
                        >
                          <option value={"null"}>Select</option>
                          {states.map((state) => {
                            return (
                              <option value={state.name} key={state.name}>
                                {state.name}
                              </option>
                            );
                          })}
                        </select>
                        <div
                          className="ErrorLog"
                          style={{
                            display: this.state.stateEmpty ? "block" : "none",
                          }}
                        >
                          <span>State is required</span>
                        </div>
                      </div>
                    ) : (
                      <div className="jobViewData">{this.state.state}</div>
                    )}
                  </div>
                </div>
                <div className="formInnerRow halfRow">
                  <div className="innerRowDiv">
                    <div className="formInputLabelNewHalf">Zip code</div>
                    <div className="formInputDiv customInput3">
                      {isEditing ? (
                        <div>
                          <input
                            type="number"
                            id="zipcode"
                            name="zipcode"
                            value={this.state.zipcode}
                            className="textInput"
                            onChange={this.inputHandleChange}
                          />
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.zipCodeEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Zip code is required</span>
                          </div>
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.zipCodeMinus
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Minus values are not allowed</span>
                          </div>
                        </div>
                      ) : (
                        <div className="jobViewData">{this.state.zipcode}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="formMainRow">
                <div className="formInnerRow">
                  <div className="formInputLabelNew">Joined</div>
                  <div className="formInputDiv">
                    <div className="jobViewData">{this.state.created_at}</div>
                  </div>
                </div>
              </div>
              {(this.state.userRole === "Surveyor" ||
                this.state.userRole === "Surveyor user") && (
                <div className="formMainRow">
                  <div className="formInnerRow">
                    <div className="formInputLabelNew">Equipments</div>
                    <div className="formInputDiv">
                      {isEditing && this.state.equipments !== null ? (
                        <div>
                          <div className="equipment-tag">
                            <ul className="equipment-tag__tags">
                              {this.state.equipments.map((tag, i) => (
                                <li key={tag}>
                                  {tag}
                                  <button
                                    type="button"
                                    onClick={() => {
                                      this.removeTag(i);
                                    }}
                                  >
                                    +
                                  </button>
                                </li>
                              ))}
                              <li className="equipment-tag__tags__input">
                                <input
                                  placeholder="Enter equipments"
                                  type="text"
                                  onKeyDown={this.inputKeyDown}
                                  ref={(c) => {
                                    this.tagInput = c;
                                  }}
                                />
                              </li>
                            </ul>
                          </div>
                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.equipmentsEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Equipments are required</span>
                          </div>
                        </div>
                      ) : (
                        <div className="jobViewData">
                          {this.state.equipments !== null &&
                          this.state.equipments.length >= 0
                            ? this.state.equipments.map((tag, i) => (
                                <span key={tag}>{tag} ,</span>
                              ))
                            : this.state.equipments}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {(this.state.userRole === "Surveyor" ||
                this.state.userRole === "Surveyor user") && (
                <div className="formMainRow">
                  <div className="formInnerRow">
                    <div className="formInputLabelNew">Signature</div>
                    <div className="formInputDiv">
                      {isEditing ? (
                        <div>
                          <div className="jobViewData">
                            {isDeleted ||
                            this.state.signature_image_url === false ? (
                              <FilePond
                                allowFileTypeValidation={true}
                                acceptedFileTypes={["image/png", "image/jpeg"]}
                                imagePreviewMaxHeight="128"
                                name="files"
                                ref={(ref) => (this.pond = ref)}
                                files={this.state.files}
                                allowMultiple={false}
                                maxFiles={1}
                                labelIdle="Drop your signature here"
                                onupdatefiles={(fileItems) => {
                                  // Set currently active file objects to this.state
                                  this.setState({
                                    files: fileItems.map(
                                      (fileItem) => fileItem.file
                                    ),
                                  });
                                }}
                              ></FilePond>
                            ) : (
                              <div
                                className="image-area"
                                style={{
                                  width: "200px",
                                  display:
                                    this.state.signature_image_url !== false
                                      ? "block"
                                      : "none",
                                }}
                              >
                                <img
                                  src={this.state.signature_image_url}
                                  alt=""
                                  style={{
                                    width: "200px",
                                  }}
                                />
                                <button
                                  onClick={(e) => {
                                    this._deleteSignature(e);
                                  }}
                                  type="button"
                                  className="remove-image"
                                  style={{ display: "inline" }}
                                >
                                  &#215;
                                </button>
                              </div>
                            )}
                          </div>

                          <div
                            className="ErrorLog"
                            style={{
                              display: this.state.signatureEmpty
                                ? "block"
                                : "none",
                            }}
                          >
                            <span>Signature is required</span>
                          </div>
                        </div>
                      ) : (
                        <div className="jobViewData">
                          <img
                            src={
                              this.state.signature_image_url !== false
                                ? this.state.signature_image_url
                                : undefined
                            }
                            alt=""
                            style={{ height: "140px" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="submitButtons">
                <div className="userCreationMessageDiv">
                  <div
                    className="userCreationMessage messageResponsive"
                    id="userCreationMessage"
                  >
                    {isSubmitted ? (
                      userCreationSuccess ? (
                        <div className="messageBody userCreationSuccessColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          <div className="userCreationSuccess">
                            Profile updated successfully
                          </div>
                        </div>
                      ) : (
                        <div className="messageBody userCreationFailColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          <div className="userCreationFail">Error</div>
                        </div>
                      )
                    ) : null}
                  </div>
                  {isEditing ? (
                    <div className="createButtonsDiv">
                      <button
                        // type="submit"
                        className="formSubmit jobCreateNewButton"
                        onClick={(e) => this.cancelSubmit(e)}
                        disabled={submitDisabled}
                      >
                        <div>
                          <span>Cancel</span>
                        </div>
                      </button>
                      <button
                        // type="submit"
                        className="formSubmit jobPostButton"
                        onClick={(e) => this.submitEdit(e)}
                        disabled={submitSaveDisabled}
                      >
                        {isSaveLoading ? (
                          <CircularProgress className="circularColor2" />
                        ) : (
                          <div>
                            <span>Save</span>
                          </div>
                        )}
                      </button>
                    </div>
                  ) : this.state.isLoggedUser ? (
                    <button
                      // type="submit"
                      className="formSubmit jobPostButton"
                      onClick={(e) => this.editProfile(e)}
                      disabled={submitDisabled}
                    >
                      <div>
                        <span>Edit profile</span>
                      </div>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default ProfileDetails;



// WEBPACK FOOTER //
// ./src/pages/Users/ProfileDetails.js